<template>
  <v-card flat>
    <v-card-title class="title-font">
      <v-icon
        v-if="!optionalCheck"
        :color="file ? 'success' : 'error'"
        class="mr-2"
      >
        {{ file ? "mdi-check-circle" : "mdi-close-circle" }}
      </v-icon>
      <v-icon v-if="optionalCheck" color="secondary" class="mr-2">
        mdi-minus-circle
      </v-icon>
      {{ categoryTitle }}
      <v-tooltip top class="rounded-10">
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="mx-2" small v-bind="attrs" v-on="on">
            mdi-file-multiple-outline
          </v-icon>
        </template>
        <span>Upload one or more files</span>
      </v-tooltip>
      <small v-if="categorySubtitle" class="font-weight-medium"
        >{{ categorySubtitle }}
      </small>
    </v-card-title>
    <v-card-subtitle class="error--text ml-3" v-if="error">
      Required
    </v-card-subtitle>
    <v-checkbox
      v-if="category == 'construction_file'"
      v-model="osteonDesign"
      label="Click here if the final tooth design is from Osteon"
      class="mt-0 pt-0 ml-4 font-weight-light text-caption"
      hide-details
      dense
    />
    <v-card-text>
      <v-row>
        <v-col cols="5">
          <ExistingFileUploader v-model="file" :category="category" />
        </v-col>
        <v-col cols="5">
          <FileUploader
            v-model="file"
            text="Upload"
            :fileType="fileType"
            :category="category"
          />
        </v-col>
        <v-col cols="2" v-for="(f, index) in files" :key="index">
          <v-badge
            bordered
            color="error"
            icon="mdi-close"
            overlap
            right
            @click.native="removeFile(index)"
          >
            <v-tooltip top class="rounded-10">
              <template v-slot:activator="{ on, attrs }">
                <v-card
                  outlined
                  class="rounded-10 overflow-hidden grey-border"
                  height="86"
                  width="86"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop
                  :ripple="false"
                >
                  <ModelViewer
                    v-if="fileType === 'scan' && f"
                    :filename="f.file_name"
                    :url="f.url"
                    :height="80"
                    :width="80"
                    class="pa-0 ma-0"
                  />
                  <v-img
                    v-if="fileType === 'photo' && f"
                    contain
                    height="100%"
                    :src="f.url"
                  />
                </v-card>
              </template>
              <span>{{ f.file_name }}</span>
            </v-tooltip>
          </v-badge>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import client from "@/lib/ApiClient"
import ExistingFileUploader from "./FileUploadAndPreview/ExistingFileUploader.vue"
import FileUploader from "./FileUploadAndPreview/FileUploader.vue"
import ModelViewer from "@/components/shared/ModelViewer.vue"

export default {
  name: "MultipleFileUploadsAndPreview",

  props: [
    "value",
    "categoryTitle",
    "category",
    "categorySubtitle",
    "fileType",
    "optional"
  ],

  inject: ["form"],

  components: { ExistingFileUploader, FileUploader, ModelViewer },

  data() {
    return {
      error: null,
      file: null,
      osteonDesign: false
    }
  },

  computed: {
    files: {
      get() {
        return this.value
      },

      async set(value) {
        this.$emit("input", value)
      }
    },

    optionalCheck() {
      if (this.category === "construction_file") {
        if (this.osteonDesign) return true
        return false
      } else {
        return this.optional
      }
    }
  },

  watch: {
    async file(value) {
      if (value) {
        await client.oft.getFileUrls(value)
        this.files.push(value)
      }
    }
  },

  methods: {
    validate() {
      this.error = null
      if (!this.files.length && !this.optionalCheck) {
        this.error = "Must be selected"
        return false
      }
      return true
    },

    removeFile(index) {
      this.files.splice(index, 1)
    }
  },

  created() {
    this.form.register(this)
  }
}
</script>
